"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermsRegistrationFooterContribution = void 0;
const react_1 = __importDefault(require("react"));
const inversify_1 = require("inversify");
const react_router_dom_1 = require("react-router-dom");
let TermsRegistrationFooterContribution = class TermsRegistrationFooterContribution {
    getFooter() {
        return (react_1.default.createElement("span", { className: "leading-normal font-normal text-interface-foreground-default-primary antialiased" },
            "By creating an account you accept the",
            ' ',
            react_1.default.createElement(react_router_dom_1.Link, { to: "/terms-of-service", className: "text-button-link-brand-brand underline transition-colors hover:text-button-link-brand-brand-hover" }, "terms"),
            "."));
    }
    getWeight() {
        return 100;
    }
};
exports.TermsRegistrationFooterContribution = TermsRegistrationFooterContribution;
exports.TermsRegistrationFooterContribution = TermsRegistrationFooterContribution = __decorate([
    (0, inversify_1.injectable)()
], TermsRegistrationFooterContribution);
